import React, { useEffect, useState } from "react"
import "./Costo.css"
import tec from "./tec.png"
import Card from "./Card"
import { useNavigate } from "react-router-dom"
import api from "../../../httpd/api"
import Espanol from "../../../Components/Ingles/Espanol";
import Ingles from "../../../Components/Ingles/Ingles";
import FooterMovil from "../../../Components/FooterMovil/FooterMovil"
import CardIngles from "./CardIngles"

function Costo() {
  let navigate = useNavigate()

  const [resultados, setResultados] = useState([])
  const [porcentajeTotal, setPorcentajeTotal] = useState("")
  const [loading, setLoading] = useState(true)
  const [isEnglish, setisEnglish] = useState(false); // ESTE VARIABLE SE REFIERE AL IDIOMA NO A SI ESTA LOGEADO O NO
  const [msj, setMsj] = useState("")
  const [msjEn, setMsjEn] = useState("")

  const fetchCalculo = async (rubros, paisId, ciudadId) => {
    const response = await api.getCalculateRubros(rubros, paisId, ciudadId)
    console.log((response.data.resultados))
    setResultados(response.data.resultados)
    setPorcentajeTotal(
      response.data.porcentaje_total
    )
    setMsj(response.data.mensaje)
    setMsjEn(response.data.mensaje_en)
    setLoading(false)
  }

  useEffect(() => {
    if (localStorage.getItem("ingles") == null) {
      localStorage.setItem("ingles", 0) // si no hay una opción seleccionada lo pongo en español
    }
    setisEnglish(localStorage.getItem("ingles"))

    const rubros = JSON.parse(localStorage.getItem("rubsSelected"))
    const pais = parseInt(localStorage.getItem("paisID"))
    const ciudad = parseInt(localStorage.getItem("ciudadID"))

    fetchCalculo(rubros, pais, ciudad)
  }, [])

  const onSubmitR = () => {
    navigate("../rubro")
  }

  const navHome = () => {
    navigate("../")
  }

  if (loading) return null

  // eslint-disable-next-line eqeqeq
  if (isEnglish == 0) return (
    <>
      <Espanol handleEvent={setisEnglish} />

      <div className="costo">
        <img className="logotec" src={tec} alt="logo of tec" onClick={navHome} />
        <div className="costo-content">
          <p className="titulocosto">
            El costo de vida en {resultados[0].ciudad_destino} es un {porcentajeTotal} {msj} en {resultados[0].ciudad_origen}.
          </p>
          <p className="sub">*Todos los precios se encuentran en dólares.</p>

          <div className="row">
            {resultados.map((card, index) => {
              return (
                <div
                  className="col-lg-4 col-md-6 col-12 g-4"
                  key={card.id}
                >
                  <Card
                    title={card.nombre_categoria}
                    imgSource={"./logos/" + card.icono}
                    porcentaje={card.total}
                    paisori={card.ciudad_origen}
                    ciudad={card.ciudad_destino}
                    cantpais={card.suma_ciudad_origen.toFixed(2)}
                    cantciudad={card.suma_ciudad_destino.toFixed(2)}
                    resumen={{
                      destino: card.resumen_destino,
                      origen: card.resumen_origen,
                    }}
                  />
                </div>
              )
            })}
          </div>
          <div className="button-container">
            <button className="botoncosto" onClick={onSubmitR}>
              Regresar
            </button>
          </div>
        </div>
        <FooterMovil />
      </div>

    </>
  )
  else return (
    <>
      <Ingles handleEvent={setisEnglish} />

      <div className="costo">
        <img className="logotec" src={tec} alt="logo of tec" onClick={navHome} />
        <div className="costo-content">
          <p className="titulocosto">
            Cost of living in {resultados[0].ciudad_destino_en} is {porcentajeTotal} {msjEn} in {resultados[0].ciudad_origen_en}.
          </p>
          <p className="sub">*All prices are in dollars </p>
          <div className="row px-md-5">
            {resultados.map((card, index) => {
              return (
                <div
                  className="col-lg-4 col-md-6 col-12 g-4"
                  key={card.id}
                >
                  <CardIngles
                    title={card.category_name}
                    imgSource={"./logos/" + card.icono} //checar lo de los logos que no salen :)
                    porcentaje={card.total}
                    paisori={card.ciudad_origen_en}
                    ciudad={card.ciudad_destino_en}
                    cantpais={card.suma_ciudad_origen.toFixed(2)}
                    cantciudad={card.suma_ciudad_destino.toFixed(2)}
                    resumen={{
                      destino: card.resumen_destino,
                      origen: card.resumen_origen,
                    }}
                  />
                </div>
              )
            })}
          </div>
          <div className="button-container">
            <button className="botoncosto" onClick={onSubmitR}>
              Return
            </button>
          </div>
        </div>

        <FooterMovil />
      </div>

    </>
  )

}

export default Costo
